<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="套餐规则">
                <a-input
                  placeholder="请选择套餐规则"
                  v-model="selectedParentPackageName"
                  read-only
                  style="width: 100%"
                  allow-clear
                  @click="showParentPackageModal = true"
                >
                  <a-icon slot="suffix" type="search" @click="showParentPackageModal = true" />
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="名称">
                <a-input v-model="queryParam.packageName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="状态">
                <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option :value="0"> 禁用 </a-select-option>
                  <a-select-option :value="1"> 启用 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="value"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button
          type="primary"
          @click="handleAddChildPackage"
          v-hasPermi="['edc3d11367c10d4dd99dddeaf314fcecc:0:c']"
          :disabled="!queryParam.packagePid"
        >
          新增
        </a-button>
        <a-button
          type="primary"
          @click="handleExport"
          v-hasPermi="['f1cd1866042366980928047f4b501a4de:0:e']"
          :disabled="true"
        >
          导出
        </a-button>
      </div>
      <CreateForm ref="CreateForm" @ok="getList"></CreateForm>
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{
          type: isSingleSelect ? 'radio' : 'checkbox',
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :pagination="false"
      >
        <span slot="coverImageUrl" slot-scope="text, record">
          <div v-viewer v-if="record.coverImageUrl">
            <img :src="$url + record.coverImageUrl" alt="" style="width: 50px; height: 50px" />
          </div>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status === 1"
            @change="(checked) => handleStatusChange(record, checked)"
            :loading="record.statusLoading"
            checked-children="启用"
            un-checked-children="禁用"
          />
        </span>
        <span slot="packageName" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.packageName">
            <span class="text-ellipsis">{{ record.packageName }}</span>
          </a-tooltip>
        </span>
        <span slot="price" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.price">
            <span class="text-ellipsis">{{ record.price }}</span>
          </a-tooltip>
        </span>
        <span slot="unitPrice" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.unitPrice">
            <span class="text-ellipsis">{{ record.unitPrice }}</span>
          </a-tooltip>
        </span>
        <span slot="capacity" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.capacity">
            <span class="text-ellipsis">{{ $formatCapacity(record.capacity) }}</span>
          </a-tooltip>
        </span>
        <span slot="description" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.description">
            <span class="text-ellipsis">{{ record.description }}</span>
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.createTime">
            <span class="text-ellipsis">{{ record.createTime }}</span>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button
            type="link"
            size="small"
            :disabled="record.status !== 0"
            @click="handleDelete(record, undefined)"
            v-hasPermi="['edc3d11367c10d4dd99dddeaf314fcecr:0:r']"
            :style="record.status !== 0 ? { color: 'rgba(0, 0, 0, 0.25)', cursor: 'not-allowed' } : {}"
          >
            删除
          </a-button>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />

      <a-modal
        title="选择套餐规则"
        :width="1200"
        :visible="showParentPackageModal"
        @ok="handleParentPackageSelect"
        @cancel="showParentPackageModal = false"
        :confirmLoading="parentModalLoading"
      >
        <div class="table-page-search-wrapper">
          <a-form layout="inline" labelAlign="right">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item label="套餐类型">
                  <a-select
                    placeholder="请选择"
                    v-model="parentPackageQuery.packageType"
                    style="width: 100%"
                    allow-clear
                  >
                    <a-select-option :value="1"> 安心套餐 </a-select-option>
                    <a-select-option :value="2"> 灵活套餐 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="套餐名称">
                  <a-input v-model="parentPackageQuery.packageName" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="状态">
                  <a-select placeholder="请选择" v-model="parentPackageQuery.status" style="width: 100%" allow-clear>
                    <a-select-option :value="0"> 禁用 </a-select-option>
                    <a-select-option :value="1"> 启用 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="handleParentPackageQuery"><a-icon type="search" />查询</a-button>
                  <a-button
style="margin-left: 8px"
@click="resetParentPackageQuery"
                    ><a-icon type="redo" />重置</a-button
                  >
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-table
          :loading="parentPackageLoading"
          rowKey="id"
          :columns="parentPackageColumns"
          :data-source="parentPackageList"
          :pagination="parentPackagePagination"
          @change="handleParentPackageTableChange"
          :row-selection="{
            type: 'radio',
            selectedRowKeys: selectedParentPackageKeys,
            onChange: onParentPackageSelectChange,
          }"
          :scroll="{ x: 800 }"
          @rowClick="handleRowClick"
          :customRow="customRow"
        >
          <span slot="packageType" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.packageType | formStatus(packageType)">
              <span class="text-ellipsis">{{ record.packageType | formStatus(packageType) }}</span>
            </a-tooltip>
          </span>
          <span slot="status" slot-scope="text, record">
            <a-switch
              :checked="record.status === 1"
              @change="(checked) => handleParentPackageStatusChange(record, checked)"
              :loading="record.statusLoading"
              checked-children="启用"
              un-checked-children="禁用"
            />
          </span>
          <span slot="packageName" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.packageName">
              <span class="text-ellipsis">{{ record.packageName }}</span>
            </a-tooltip>
          </span>
          <span slot="price" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.price">
              <span class="text-ellipsis">{{ record.price }}</span>
            </a-tooltip>
          </span>
          <span slot="unitPrice" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.unitPrice">
              <span class="text-ellipsis">{{ record.unitPrice }}</span>
            </a-tooltip>
          </span>
          <span slot="validDays" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.validDays">
              <span class="text-ellipsis">{{ record.validDays }}</span>
            </a-tooltip>
          </span>
          <span slot="capacity" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.capacity">
              <span class="text-ellipsis">{{ $formatCapacity(record.capacity) }}</span>
            </a-tooltip>
          </span>
        </a-table>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>
<script>
import { fetchList, delObj, editStatus, getPackageDetail } from '@/api/VR/storagePackage'
import CreateForm from './modules/CreateForm.vue'
import { tableMixin } from '@/store/table-mixin'
import parameter from '@/mixins/parameter'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'ChildPackage',
  components: {
    CreateForm,
  },
  mixins: [tableMixin, parameter],
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    ...mapGetters(['userTentant', 'infoUser']),
  },
  data() {
    return {
      list: [],
      selectedParentPackageName: '',
      selectedParentPackageKeys: [],
      selectedParentPackage: null,
      showParentPackageModal: false,
      parentModalLoading: false,
      parentPackageList: [],
      isSingleSelect: false,
      selectedRowIndex: null,

      parentPackageLoading: false,
      parentPackagePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      parentPackageQuery: {
        pageNum: 1,
        pageSize: 10,
        packageType: 1,
        packageName: null,
        status: null,
      },
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        packageType: 3,
        packagePid: null,
        packageName: null,
        status: null,
      },
      total: 0,
      value: [],
      advanced: false,
      loading: false,
      selectedRowKeys: [],
      parentPackageColumns: [
        {
          title: '套餐名称',
          dataIndex: 'packageName',
          key: 'packageName',
          align: 'center',
          width: '120px',
          scopedSlots: { customRender: 'packageName' },
        },
        {
          title: '套餐类型',
          dataIndex: 'packageType',
          scopedSlots: { customRender: 'packageType' },
          key: 'packageType',
          align: 'center',
          width: '100px',
        },
        {
          title: '套餐价格',
          dataIndex: 'price',
          align: 'center',
          width: '90px',
          scopedSlots: { customRender: 'price' },
        },
        {
          title: '单价(元/GB)',
          dataIndex: 'unitPrice',
          align: 'center',
          width: '100px',
          scopedSlots: { customRender: 'unitPrice' },
        },
        {
          title: '有效期(天)',
          dataIndex: 'validDays',
          align: 'center',
          width: '100px',
          scopedSlots: { customRender: 'validDays' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
          width: '100px',
        },
        {
          title: '套餐容量',
          dataIndex: 'capacity',
          key: 'capacity',
          align: 'center',
          width: '120px',
          scopedSlots: { customRender: 'capacity' },
        },
      ],
      columns: [
        {
          title: '名称',
          dataIndex: 'packageName',
          width: '120px',
          key: 'packageName',
          align: 'center',
          scopedSlots: { customRender: 'packageName' },
        },
        {
          title: '套餐价格',
          dataIndex: 'price',
          width: '90px',
          align: 'center',
          scopedSlots: { customRender: 'price' },
        },
        {
          title: '单价(元/GB)',
          dataIndex: 'unitPrice',
          width: '108px',
          align: 'center',
          scopedSlots: { customRender: 'unitPrice' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '100px',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: '套餐容量',
          dataIndex: 'capacity',
          width: '120px',
          key: 'capacity',
          align: 'center',
          scopedSlots: { customRender: 'capacity' },
        },

        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '100px',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '80px',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          fixed: 'right',
        },
      ],
    }
  },
  methods: {
    getParentPackageList() {
      this.parentPackageLoading = true

      if (this.userType == 0) {
        fetchList(this.parentPackageQuery)
          .then((res) => {
            this.parentPackageList = res.data.records.map((item) => ({
              ...item,
              statusLoading: false,
            }))
            this.parentPackagePagination.total = res.data.total
            this.parentPackagePagination.current = res.data.current
            this.parentPackageLoading = false
          })
          .catch(() => {
            this.parentPackageLoading = false
          })
      } else {
        fetchList(this.parentPackageQuery)
          .then((res) => {
            this.parentPackageList = res.data.records.map((item) => ({
              ...item,
              statusLoading: false,
            }))
            this.parentPackagePagination.total = res.data.total
            this.parentPackagePagination.current = res.data.current
            this.parentPackageLoading = false
          })
          .catch(() => {
            this.parentPackageLoading = false
          })
      }
    },
    handleStatusChange(record, checked) {
      const newStatus = checked ? 1 : 0
      const actionText = checked ? '启用' : '禁用'

      this.$confirm({
        title: `确认${actionText}`,
        content: `确定要${actionText} "${record.packageName}" 吗？`,
        onOk: () => {
          record.statusLoading = true
          return editStatus({ id: record.id })
            .then(() => {
              record.status = newStatus
              this.$message.success(`${actionText}成功`)
              this.getList()
            })
            .catch(() => {
              this.$message.error(`${actionText}失败`)
            })
            .finally(() => {
              record.statusLoading = false
            })
        },
        onCancel: () => {},
      })
    },
    handleParentPackageStatusChange(record, checked) {
      const newStatus = checked ? 1 : 0
      const actionText = checked ? '启用' : '禁用'

      this.$confirm({
        title: `确认${actionText}`,
        content: `确定要${actionText} "${record.packageName}" 套餐规则吗？`,
        onOk: () => {
          record.statusLoading = true

          return editStatus({ id: record.id })
            .then(() => {
              record.status = newStatus
              this.$message.success(`${actionText}成功`)
              this.getList()
            })
            .catch(() => {
              this.$message.error(`${actionText}失败`)
            })
            .finally(() => {
              record.statusLoading = false
            })
        },
        onCancel: () => {},
      })
    },
    handleParentPackageQuery() {
      this.parentPackageQuery.pageNum = 1
      this.getParentPackageList()
    },
    resetParentPackageQuery() {
      this.parentPackageQuery = {
        pageNum: 1,
        pageSize: 10,
        packageType: null,
        packageName: null,
        status: null,
      }
      this.getParentPackageList()
    },
    handleParentPackageTableChange(pagination) {
      this.parentPackageQuery.pageNum = pagination.current
      this.parentPackageQuery.pageSize = pagination.pageSize
      this.getParentPackageList()
    },
    onParentPackageSelectChange(selectedRowKeys, selectedRows) {
      this.selectedParentPackageKeys = selectedRowKeys
      this.selectedParentPackage = selectedRows[0] || null
      // 当通过选择框选择时，更新选中行的索引
      if (selectedRows[0]) {
        const index = this.parentPackageList.findIndex((item) => item.id === selectedRows[0].id)
        this.selectedRowIndex = index
      } else {
        this.selectedRowIndex = null
      }
    },
    handleParentPackageSelect() {
      if (!this.selectedParentPackage) {
        this.$message.warning('请选择一个套餐规则')
        return
      }

      this.queryParam.packagePid = this.selectedParentPackage.id
      this.selectedParentPackageName = this.selectedParentPackage.packageName
      this.showParentPackageModal = false
      this.queryParam.pageNum = 1
      this.getList()
    },
    getList() {
      if (!this.queryParam.packagePid) {
        this.list = []
        this.total = 0
        this.loading = false
        return
      }

      this.loading = true

      if (this.userType == 0) {
        fetchList(this.queryParam)
          .then((res) => {
            this.list = res.data.records.map((item) => ({
              ...item,
              statusLoading: false,
            }))
            this.total = res.data.total
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        fetchList(this.queryParam)
          .then((res) => {
            this.list = res.data.records.map((item) => ({
              ...item,
              statusLoading: false,
            }))
            this.total = res.data.total
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    handleAddChildPackage() {
      if (!this.queryParam.packagePid) {
        this.$message.warning('请先选择套餐规则')
        return
      }

      const parentPackage = {
        id: this.queryParam.packagePid,
        packageName: this.selectedParentPackageName,
        showTime: false,
      }
      this.$refs.CreateForm.handleAdd(parentPackage)
    },
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        packageType: 3,
        packagePid: this.queryParam.packagePid,
        packageName: null,
        status: null,
      }
      this.value = []
      this.getList()
    },
    handleExport() {
      if (!this.queryParam.packagePid) {
        this.$message.warning('请先选择套餐规则')
        return
      }

      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'vr/storage/package/export',
            {
              ...that.queryParam,
            },
            `child_package_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
    onChangeTime(e) {
      if (e && e.length === 2) {
        this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
        this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.queryParam.createBeginTime = null
        this.queryParam.createEndTime = null
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    loadParentPackageFromRoute() {
      const routeId = this.$route.query.id
      const routePackageName = this.$route.query.packageName
      const routePackageType = this.$route.query.packageType

      if (routeId) {
        this.queryParam.packagePid = routeId
        this.selectedParentPackageName = routePackageName || '加载中...'

        // 如果有传递套餐类型，设置到查询条件中
        if (routePackageType) {
          this.parentPackageQuery.packageType = parseInt(routePackageType)
        }

        this.getList()
      } else {
        this.loadDefaultParentPackage()
      }
    },
    loadDefaultParentPackage() {
      this.parentPackageLoading = true
      const defaultQuery = {
        pageNum: 1,
        pageSize: 1,
        packageType: 1,
        status: 1,
      }

      if (this.userType == 0) {
        fetchList(defaultQuery)
          .then((res) => {
            if (res.data.records && res.data.records.length > 0) {
              const defaultParent = res.data.records[0]
              this.queryParam.packagePid = defaultParent.id
              this.selectedParentPackageName = defaultParent.packageName
              this.getList()
            }
            this.parentPackageLoading = false
          })
          .catch(() => {
            this.parentPackageLoading = false
          })
      } else {
        fetchList(defaultQuery)
          .then((res) => {
            if (res.data.records && res.data.records.length > 0) {
              const defaultParent = res.data.records[0]
              this.queryParam.packagePid = defaultParent.id
              this.selectedParentPackageName = defaultParent.packageName
              this.getList()
            }
            this.parentPackageLoading = false
          })
          .catch(() => {
            this.parentPackageLoading = false
          })
      }
    },
    customRow(record, index) {
      return {
        on: {
          click: () => {
            this.handleRowClick(record, index)
          },
        },
        style: {
          cursor: 'pointer',
          'background-color': this.selectedRowIndex === index ? '#e6f7ff' : '',
          transition: 'background-color 0.3s ease',
        },
      }
    },
    handleRowClick(record, index) {
      this.selectedRowIndex = index
      this.selectedParentPackageKeys = [record.id]
      this.selectedParentPackage = record

      // 自动关闭弹框并设置选中值
      this.queryParam.packagePid = record.id
      this.selectedParentPackageName = record.packageName
      this.showParentPackageModal = false
      this.queryParam.pageNum = 1
      this.getList()
    },

    // 打开弹框时初始化选中状态
    initSelectedPackage() {
      if (this.queryParam.packagePid && this.parentPackageList.length > 0) {
        const index = this.parentPackageList.findIndex((item) => item.id === this.queryParam.packagePid)
        if (index !== -1) {
          this.selectedRowIndex = index
          this.selectedParentPackageKeys = [this.queryParam.packagePid]
          this.selectedParentPackage = this.parentPackageList[index]
        }
      } else {
        this.selectedRowIndex = null
        this.selectedParentPackageKeys = []
        this.selectedParentPackage = null
      }
    },
  },
  created() {
    this.loadParentPackageFromRoute()
    this.getParentPackageList()
  },
  watch: {
    '$route.query.id': {
      handler(newId) {
        if (newId) {
          this.loadParentPackageFromRoute()
        }
      },
      immediate: false,
    },
    // 监听弹框显示状态，打开时初始化选中状态
    showParentPackageModal(newVal) {
      if (newVal) {
        // 如果从路由传递了套餐类型，自动设置查询条件并触发查询
        if (this.$route.query.packageType) {
          const packageType = parseInt(this.$route.query.packageType)
          this.parentPackageQuery.packageType = packageType
          this.handleParentPackageQuery()
        }

        // 弹框打开后，等待数据加载完成再初始化选中状态
        this.$nextTick(() => {
          if (this.parentPackageList.length > 0) {
            this.initSelectedPackage()
          } else {
            // 如果数据还没加载，监听数据加载完成
            const unwatch = this.$watch('parentPackageList', (newList) => {
              if (newList.length > 0) {
                this.initSelectedPackage()
                unwatch() // 取消监听
              }
            })
          }
        })
      }
    },
    // 监听数据列表变化，初始化选中状态
    parentPackageList(newList) {
      if (this.showParentPackageModal && newList.length > 0) {
        this.initSelectedPackage()
      }
    },
  },
}
</script>
<style lang="less" scoped>
.ant-table {
  .text-ellipsis {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  text-align: center;
  vertical-align: middle;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  gap: 8px;
}

.ant-table-pagination {
  margin-top: 16px;
  text-align: center;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.ant-form-item {
  margin-bottom: 16px;
}

.ant-table-wrapper {
  overflow-x: auto;
}

.ant-table-tbody > tr > td {
  padding: 8px;
}

.ant-table-thead > tr > th {
  padding: 12px 8px;
  font-weight: 600;
}

.ant-modal-body {
  .ant-table-wrapper {
    margin-top: 16px;
  }
}

.ant-table-selection-column {
  text-align: center;
}

.ant-table-fixed-right .ant-table-tbody > tr > td,
.ant-table-fixed-right .ant-table-thead > tr > th {
  text-align: center;
}
</style>
